export const STATUS_FLOW = ["placed", "confirmed", "preparing", "shipped", "out_for_delivery", "delivered"];

export function statusLabel(t, status) {
  return t(`status_${status}`);
}

export function statusColor(status) {
  const map = {
    placed: "bg-stone-100 text-stone-700",
    confirmed: "bg-blue-100 text-blue-700",
    preparing: "bg-amber-100 text-amber-700",
    shipped: "bg-indigo-100 text-indigo-700",
    out_for_delivery: "bg-mango-600/15 text-mango-700",
    delivered: "bg-emerald-100 text-emerald-800",
  };
  return map[status] || "bg-stone-100 text-stone-700";
}
